module.exports = __webpack_public_path__ + "media/images/country_flags/ga-c6d1de2a097a7d931ae5f266a51ede19.png";